import { graphql } from '~/gql';

export const CreateExpertStripeOnboardingLinkDocument = graphql(`
  mutation CreateExpertStripeOnboardingLink {
    createExpertStripeOnboardingLink
  }
`);
